import { render, staticRenderFns } from "./AssetEdit.vue?vue&type=template&id=0bfd0934&scoped=true"
import script from "./AssetEdit.vue?vue&type=script&lang=js"
export * from "./AssetEdit.vue?vue&type=script&lang=js"
import style0 from "./AssetEdit.vue?vue&type=style&index=0&id=0bfd0934&prod&lang=scss"
import style1 from "./AssetEdit.vue?vue&type=style&index=1&id=0bfd0934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfd0934",
  null
  
)

export default component.exports